<template>
  <div class="item">
    <div class="restaurant-name">
      {{ orderDeliveredDetails.restaurantName }}
    </div>
    <div class="user-name">{{ orderDeliveredDetails.userName }}</div>
    <div class="date">{{ orderDeliveredDetails.date.toDate() }}</div>
    <div class="total-price">S${{ orderDeliveredDetails.totalPrice }}</div>
    <div class="reward-earned">S${{ orderDeliveredDetails.saviourPerk }}</div>
  </div>
</template>

<script>
export default {
  name: "OrderDeliveredDashboard",
  props: ["orderDeliveredDetails"],
};
</script>

<style lang="scss" scoped>
.item {
  display: flex;
  flex-direction: column;
  background-color: #f1f1f1;
  padding: 20px 8px;
  margin: 0 5px 5px 5px;
  border-radius: 8px;
  gap: 10px;

  @media (min-width: 800px) {
    flex-direction: row;
    gap: 0px;
  }

  .restaurant-name {
    flex-basis: 25%;
    display: flex;
    justify-content: center;
  }

  .user-name {
    flex-basis: 25%;
    display: flex;
    justify-content: center;
  }

  .date {
    flex-basis: 20%;
    display: flex;
    justify-content: center;
  }

  .total-price {
    flex-basis: 15%;
    display: flex;
    justify-content: center;
  }

  .reward-earned {
    flex-basis: 15%;
    display: flex;
    justify-content: center;
  }
}
</style>
